/**
 * Mouse Cursor - Custom Cursor — replaces the page cursor
 *
 * Its single web-accessible-resource entry is matched to every origin and its
 * `resources` are the globs `assets/*.*` and `libs/*.*`, with no
 * `use_dynamic_url`. Those cover the bundled PNG icons under `assets/`, so each
 * is fetchable from any page at a fixed URL — served only when the extension is
 * installed, with the ID in the URL.
 *
 * Manifest verified against version 4.2.0.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kinfihfgknmecicjmadebldjeknakbpj';

export const mouseCursor: ExtensionDefinition = {
  id: ID,
  name: 'Mouse Cursor - Custom Cursor',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 10_000,
  notes:
    'assets/*.* WAR glob on every origin with no dynamic URL exposes the bundled icons. ' +
    'Detection loads an <img> with no CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load assets/icon128.png via <img> — exposed to every origin and readable without ' +
        'a CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'assets/icon128.png'),
    },
    {
      id: 'war-icons-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load assets/icons/icon-128.png via <img> — a second bundled icon, corroborating ' +
        'the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/icons/icon-128.png'),
    },
  ],
};
